var _rect, _circle, _rect2, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _path, _path2, _path3, _line14, _line15, _line16, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatherTimeResult2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 360,
    viewBox: "0 0 422 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206.696,
    y: 111.925,
    width: 14.0046,
    height: 6.39726,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213.699,
    cy: 205.74,
    r: 85.2603,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 194.614,
    y: 98.5,
    width: 38.1689,
    height: 11.3196,
    rx: 5.65982,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.699,
    cy: 205.74,
    r: 78.9954,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 215.699,
    y1: 132.352,
    x2: 215.699,
    y2: 146.224,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 178.936,
    y1: 141.368,
    x2: 185.872,
    y2: 153.382,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 149.155,
    y1: 240.702,
    x2: 161.169,
    y2: 233.766,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 175.273,
    y1: 268.308,
    x2: 182.209,
    y2: 256.295,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 151.155,
    y1: 167.314,
    x2: 163.169,
    y2: 174.25,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 140.311,
    y1: 203.74,
    x2: 154.183,
    y2: 203.74,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 215.699,
    y1: 265.256,
    x2: 215.699,
    y2: 279.128,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 245.389,
    y1: 256.466,
    x2: 252.325,
    y2: 268.48,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 264.254,
    y1: 174.25,
    x2: 276.267,
    y2: 167.314,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 241.724,
    y1: 153.21,
    x2: 248.661,
    y2: 141.196,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 266.254,
    y1: 233.766,
    x2: 278.267,
    y2: 240.702,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 273.215,
    y1: 203.74,
    x2: 287.087,
    y2: 203.74,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 284.375,
    y1: 248.544,
    x2: 313.82,
    y2: 265.544,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.12 279.28V283H329.808V279.28H321.84V276.88L330.168 266.2H333.12V276.568H335.184V279.28H333.12ZM325.56 276.568H329.808V271.144H329.76L325.56 276.52V276.568ZM349.036 271.8L353.036 283H350.828L349.98 280.584H345.788L344.94 283H342.732L346.732 271.8H349.036ZM347.868 274.616L346.46 278.664H349.292L347.9 274.616H347.868ZM364.057 283V275.608H364.025L361.497 283H359.369L356.825 275.512H356.793V283H354.633V271.8H357.609L360.425 280.04H360.457L363.257 271.8H366.217V283H364.057ZM367.97 283.32L371.746 271.48H373.826L370.05 283.32H367.97ZM375.587 283V271.8H381.491L383.347 272.872V277.864L381.491 278.936H377.827V283H375.587ZM377.827 273.72V277.016H381.107V273.72H377.827ZM395.011 283V275.608H394.979L392.451 283H390.323L387.779 275.512H387.747V283H385.587V271.8H388.563L391.379 280.04H391.411L394.211 271.8H397.171V283H395.011Z",
    fill: "#FFF761"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5192 326H75.9912L82.4472 312.128V312.08H77.0472V314.24H73.6872V309.2H86.2872V311.36L79.5192 326ZM100.146 314.8L104.146 326H101.938L101.09 323.584H96.8976L96.0496 326H93.8416L97.8416 314.8H100.146ZM98.9776 317.616L97.5696 321.664H100.402L99.0096 317.616H98.9776ZM115.167 326V318.608H115.135L112.607 326H110.479L107.935 318.512H107.903V326H105.743V314.8H108.719L111.535 323.04H111.567L114.367 314.8H117.327V326H115.167ZM119.08 326.32L122.856 314.48H124.936L121.16 326.32H119.08ZM126.696 326V314.8H132.6L134.456 315.872V320.864L132.6 321.936H128.936V326H126.696ZM128.936 316.72V320.016H132.216V316.72H128.936ZM146.12 326V318.608H146.088L143.56 326H141.432L138.888 318.512H138.856V326H136.696V314.8H139.672L142.488 323.04H142.52L145.32 314.8H148.28V326H146.12Z",
    fill: "#FFF761"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3486 131.816V128.672L16.6686 126.2H19.5486V140.12H23.3886V143H12.3486V140.12H16.1886V129.608L12.3486 131.816ZM38.3905 141.512L35.6065 143.12H29.0545L26.2705 141.512V127.688L29.0545 126.08H35.6065L38.3905 127.688V141.512ZM29.6305 128.96V140.24H35.0305V128.96H29.6305ZM53.2042 131.8L57.2042 143H54.9962L54.1482 140.584H49.9562L49.1082 143H46.9002L50.9002 131.8H53.2042ZM52.0362 134.616L50.6282 138.664H53.4602L52.0682 134.616H52.0362ZM68.2254 143V135.608H68.1934L65.6654 143H63.5374L60.9934 135.512H60.9614V143H58.8014V131.8H61.7774L64.5934 140.04H64.6254L67.4254 131.8H70.3854V143H68.2254ZM72.1383 143.32L75.9143 131.48H77.9943L74.2183 143.32H72.1383ZM79.7545 143V131.8H85.6585L87.5145 132.872V137.864L85.6585 138.936H81.9945V143H79.7545ZM81.9945 133.72V137.016H85.2745V133.72H81.9945ZM99.1785 143V135.608H99.1465L96.6185 143H94.4905L91.9465 135.512H91.9145V143H89.7545V131.8H92.7305L95.5465 140.04H95.5785L98.3785 131.8H101.339V143H99.1785Z",
    fill: "#FFF761"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 255.701,
    y1: 127.829,
    x2: 272.201,
    y2: 99.25,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 169.077,
    y1: 277.247,
    x2: 151.296,
    y2: 307.755,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 132.821,
    y1: 161.044,
    x2: 98.1798,
    y2: 141.044,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.446 79.816V76.672L278.766 74.2H281.646V88.12H285.486V91H274.446V88.12H278.286V77.608L274.446 79.816ZM299.107 79.8L303.107 91H300.899L300.051 88.584H295.859L295.011 91H292.803L296.803 79.8H299.107ZM297.939 82.616L296.531 86.664H299.363L297.971 82.616H297.939ZM314.128 91V83.608H314.096L311.568 91H309.44L306.896 83.512H306.864V91H304.704V79.8H307.68L310.496 88.04H310.528L313.328 79.8H316.288V91H314.128ZM318.041 91.32L321.817 79.48H323.897L320.121 91.32H318.041ZM325.657 91V79.8H331.561L333.417 80.872V85.864L331.561 86.936H327.897V91H325.657ZM327.897 81.72V85.016H331.177V81.72H327.897ZM345.081 91V83.608H345.049L342.521 91H340.393L337.849 83.512H337.817V91H335.657V79.8H338.633L341.449 88.04H341.481L344.281 79.8H347.241V91H345.081Z",
    fill: "#FFF761"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatherTimeResult2);
export default __webpack_public_path__ + "static/media/gatherTimeResult2.a83a2cced4dd7074775f443b100f84a9.svg";
export { ForwardRef as ReactComponent };